import React from "react";
import { PlanLevelCommunicationContainer } from "../../../containers";
import { withAppLayout } from "../../../hoc";

const PlanLevelCommunication = (props) => {
  return <PlanLevelCommunicationContainer {...props} />;
};

export default PlanLevelCommunication;
